<template>
  <div>
    <Breadcrumbs main="" title="shipShore.header" />
    <b-container fluid>
      <!-- <h3 class="mb-1 mt-4 f-w-600">{{ $t('matchTx.header') }}</h3> -->
      <div>
        <div>
          <div class="d-flex flex-row justify-content-between mr-5">
            <span class=" ml-3 f-w-600" style="font-size: 22px;">{{ $t('shipShore.shoreApproval') }}</span>             
            <!-- <b-button  pill size="md" @click="shipApproval" class="bg-primary mb-4" >
              <span class="f-w-600 text-white" style="font-size: 18px;">{{ $t('sidebar.Approval') }} </span>
            </b-button>  -->
            <div class="row">
                <router-link to="/dashboard/homePageAgent">
                    <feather  v-b-tooltip.hover :title="$t('homePageAgent.header')" type="home" class="mx-2"></feather>
                </router-link>
                <router-link to="/eBooking/agentBookingTx">
                    <feather  v-b-tooltip.hover :title="$t('homePageAgent.issueBooking')" type="book-open" class="mx-2"></feather>
                </router-link>
                <router-link to="/dashboard/shipApproval">
                    <feather  v-b-tooltip.hover :title="$t('homePageAgent.matching')" type="link" class="mx-2"></feather>
                </router-link>
                <!-- <router-link to="/process/shipShore">
                    <feather  v-b-tooltip.hover :title="$t('homePageAgent.shoreApproval')" type="tag" class="mx-2"></feather>
                </router-link> -->
            </div>
            <div v-if="isGenerating" class="ml-3" style="margin-top: 10px;">
              <progress :value="progressValue" max="100"></progress>
              <span class="text-danger" style="font-size: 18px;">EIR Generating Progress => {{ progressValue }} %</span>
            </div>
          </div>
          <b-row>
            <b-col lg="5" class="my-1">
              <b-form-group
                :label="$t('matchTx.sort')"
                label-for="sort-by-select-shipShore"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="lg"
                class="mb-0"
                v-slot="{ ariaDescribedby }"
              >
                <b-input-group size="lg">
                  <b-form-select
                    id="sort-by-select-shipShore"
                    v-model="sortBy"
                    :options="sortOptions"
                    :aria-describedby="ariaDescribedby"
                    class="w-70 text-info"
                  >
                    <template #first>
                      <option value="">-- none --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDesc"
                    :disabled="!sortBy"
                    :aria-describedby="ariaDescribedby"
                    size="lg"
                    class="w-30 text-info"
                  >
                    <option :value="false">{{$t('matchTx.asc')}}</option>
                    <option :value="true">{{$t('matchTx.desc')}}</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col lg="5" class="my-1">
              <b-form-group
                :label="$t('matchTx.initSort')"
                label-for="initial-sort-select-shipShore"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="lg"
                class="mb-0"
              >
                <b-form-select
                  id="initial-sort-select-shipShore"
                  v-model="sortDirection"
                  :options="['asc', 'desc', 'last']"
                  size="lg"
                  class="text-info"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="5" class="my-1">
              <b-form-group
                :label="$t('matchTx.filter')"
                label-for="filter-input-shipShore"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="lg"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input-shipShore"
                    v-model="filter"
                    type="search"
                    :placeholder="$t('matchTx.typeToSearch')"
                    class="text-info"
                    style="font-size: 18px;"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button size="md" variant="primary" :disabled="!filter" @click="filter = ''">
                      {{ $t('matchTx.clear') }}
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col lg="5" class="my-1">
              <b-form-group
                v-model="sortDirection"
                :label="$t('matchTx.filterOn')"
                :description= "$t('matchTx.uncheck')"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="lg"
                class="mb-0"
                v-slot="{ ariaDescribedby }"
              >
                <b-form-checkbox-group
                  v-model="filterOn"
                  :aria-describedby="ariaDescribedby"
                  class="mt-1 text-info"
                  plain
                >
                  <b-form-checkbox value="bkgId">{{ $t('matchTx.bkgId') }}</b-form-checkbox>
                  <b-form-checkbox value="contNo">{{ $t('matchTx.contNo') }}</b-form-checkbox>     
                  <b-form-checkbox value="contSize">{{ $t('matchTx.contSize') }}</b-form-checkbox>   
                  <b-form-checkbox value="contType">{{ $t('matchTx.contType') }}</b-form-checkbox>   
                  <b-form-checkbox value="contGrade">{{ $t('matchTx.contGrade') }}</b-form-checkbox>
                  <b-form-checkbox value="sealNo">{{ $t('matchTx.sealNo') }}</b-form-checkbox>  
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="row justify-content-start ml-2">
            <feather 
                @click="refresh" 
                class="text-primary" 
                type="refresh-cw"  
                size="25" 
                v-b-popover.hover.top="$t('approvedTrans.refreshTaskListMsg')">
            </feather>  
              <span class="texrt-dark mx-2"> {{ $t('approvedTrans.asOf') }}</span>
              <span class="text-primary"> {{ asOf }} </span>   
          </div>
          <b-table
            sticky-header
            head-variant="light"
            table-variant="info"
            show-empty
            sort-icon-left
            stacked="md"
            :busy="isBusy"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            @filtered="onFiltered"
          >
            <template #cell(contImage)="row" >
              <b-button  size="md" @click="openModalImage(row.item, $event.target )" class="m-1">
                {{ row.item.contNo }}
              </b-button>
            </template>
            <template #cell(actShore)="row" >
              <b-button size="md" variant="danger" @click="actShipShoreReject(row.item)" class="m-1">
                {{ $t('matchTx.reject') }}
              </b-button>
              <b-button v-show="row.item.status" size="md" variant="primary" @click="actShipShoreAccept(row.item)" class="m-1" v-b-popover.hover.top="$t('shipShore.actShipShoreAcceptMsg')">
                {{ $t('matchTx.accept') }}
              </b-button>
            </template>
            <template #cell(actInfo)="row" >
              <b-button size="sm" variant="info" @click="actEirRels(row.item)" class="m-1" v-b-popover.hover.top="$t('matchTx.eirRelsMsg')" >
                {{ isGenerating && actEirAtLoc == 'rels' ? $t('matchTx.eirRelsGentng') : $t('matchTx.eirRels')  }}
              </b-button>
              <b-button size="sm" variant="info" @click="actEirRecv(row.item)" class="m-1" v-b-popover.hover.top="$t('matchTx.eirRecvMsg')">
                {{ isGenerating && actEirAtLoc == 'recv' ? $t('matchTx.eirRecvGentng') : $t('matchTx.eirRecv')  }}
              </b-button>
            </template>
            <template #empty>
                <h5>{{ $t('reuse.noRecord') }}</h5>
            </template>
          </b-table>
          <b-row>
            <div class="row col-sm-4 ">
              <b-col class="my-1 ml-3">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  align="fill"
                  class="my-0"
                ></b-pagination>
              </b-col>   
              <b-col sm="3" md="6" class="my-1">
                <b-form-group
                  :label= "$t('require.perPage')"
                  label-for="per-page-select"
                  label-cols-sm="6"
                  label-cols-md="4"
                  label-cols-lg="3"
                  label-align-sm="right"
                  label-size="sm"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </div>
          </b-row>
          <b-modal id="contModal" :title="modalTitle" ok-only @hide="resetInfoModal">
            <div class="row my-2">
              <h5 class="text-primary ml-2"> {{ $t('container.contNo') }}</h5>               
              <span class="text-info ml-2">{{ modalContNo }}</span>                  
            </div>
            <div class="gradient-yg p-1" >
                        <div class="dashboard">
                            <div class="image-scroll-container">
                                <div class="image-scroll" ref="scrollContainer">
                                    <div
                                    class="image-item"
                                    v-for="(image, index) in imageUriModal"
                                    :key="image.id"
                                    >
                                    <img :src="image.url" :alt="'Image ' + (index + 1)" class="display-image">
                                    <span class="image-counter">{{ index + 1 }} of {{ imageUriModal.length }}</span>
                                    </div>
                                    <div v-if="imageUriModal.length === 0" class="no-images">
                                    {{$t('approvedTrans.noImageYet') }}
                                    </div>
                                </div>
                                <div class="scroll-controls" v-if="imageUriModal.length > 1">
                                    <button @click="scrollLeft" class="scroll-btn">&lt;&lt;</button>
                                    <button @click="scrollLeftS1" class="scroll-btn mx-2">&lt;</button>
                                    <button @click="scrollRightS1" class="scroll-btn mx-2">&gt;</button>
                                    <button @click="scrollRight" class="scroll-btn">&gt;&gt;</button>
                                </div>
                            </div>                        
                        </div>
                    </div>
          </b-modal>  
          <b-modal
            id="shipShoreReject-modal" 
            :title="$t('shipShore.shipShoreRejectModalTitle')"
            v-model="showShipShoreRejectModal"
            header-bg-variant="danger"
            header-text-variant="dark"
            body-bg-variant="light"
            size = 'md'
            body-text-variant="dark"
            hide-footer
          >
            <div class="form-row">      
                <div class="col-md-12">
                  <div class="form-group">
                      <label for="remark" class="col-form-label text-primary f-w-600">{{ $t('shipApproval.rejectRemark') }}</label>
                      <input
                        class="form-control"
                        id="remark-input"
                        v-model="remark"
                        type="text"
                        :placeholder="$t('shipApproval.rejectRemarkPh')"
                        style="font-size: 16px;"
                      >                  
                    </div>
              </div>
            </div>
            <div class="w-100">
              <b-button
                variant="danger"
                size="md"
                class="float-right"
                @click="clickShipShoreReject_OK"
              >
              {{ $t('truck.ok') }}
              </b-button>              
              <b-button
                variant="warning"
                size="md"
                class="float-right"
                @click="clickShipShoreReject_NO"
              >
                {{ $t('matchTx.no') }}
              </b-button>
            </div>
          </b-modal>
          <b-modal
            id="shipShoreAccept-modal" 
            :title="$t('shipShore.shipShoreAcceptModalTitle')"
            v-model="showShipShoreAcceptModal"
            header-bg-variant="info"
            header-text-variant="dark"
            body-bg-variant="light"
            body-text-variant="dark"
            hide-footer
          >
            <div class="form-row">
                <h3 class="text-primary">{{ $t('shipShore.shipShoreAcceptData') }}</h3>              
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="vessel" class="col-form-label text-primary f-w-600">{{ $t('shipShore.vessel') }}</label>
                        <input class="form-control" id="vessel" v-model="vessel" type="text" :placeholder="$t('shipShore.vesselPh') ">
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="voyageNo" class="col-form-label text-primary f-w-600">{{ $t('shipShore.voyageNo') }}</label>
                        <input class="form-control" id="voyageNo" v-model="voyageNo" type="text" :placeholder="$t('shipShore.voyageNoPh') ">
                    </div>
                </div>                
                <div class="col-md-6">
                  <div class="form-group">
                      <label for="destPort" class="col-form-label text-primary f-w-600">{{ $t('matchTx.destPort') }}</label>
                      <input class="form-control" id="destPort" v-model="destPort" type="text">
                  </div>
                </div>                
            </div>
            <div class="w-100">
              <b-button
                variant="primary"
                size="md"
                class="float-right"
                @click="clickShipShoreAccept_OK"
              >
              {{ $t('truck.ok') }}
              </b-button>              
              <b-button
                variant="warning"
                size="md"
                class="float-right"
                @click="clickShipShoreAccept_NO"
              >
                {{ $t('matchTx.no') }}
              </b-button>
            </div>
          </b-modal>                       
        </div>
        <div class="divider my-3 mx-1"> </div>
        <div>
          <div class="d-flex flex-row justify-content-between mx-3 my-1">
           <h2 class="text-primary f-w-600">{{ $t('shipShore.shoreConsd') }}</h2> 
           <b-button
                pill
                variant="primary"
                size="lg"
                class="float-right"
                @click="exportAccept2Port_excel"
                v-b-popover.hover.top="$t('shipShore.exportShore2PortMsg')"
              >
                {{ $t('shipShore.exportShoreBtn') }}
              </b-button>
          </div>
          <b-row>
            <b-col lg="5" class="my-1">
              <b-form-group
                :label="$t('matchTx.sort')"
                label-for="sort-by-select-shipShoreConsd"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="lg"
                class="mb-0"
                v-slot="{ ariaDescribedbyConsd }"
              >
                <b-input-group size="lg">
                  <b-form-select
                    id="sort-by-select-shipShoreConsd"
                    v-model="sortByConsd"
                    :options="sortOptionsConsd"
                    :aria-describedby="ariaDescribedbyConsd"
                    class="w-70 text-info"
                  >
                    <template #first>
                      <option value="">-- none --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDescConsd"
                    :disabled="!sortByConsd"
                    :aria-describedby="ariaDescribedbyConsd"
                    size="lg"
                    class="w-30 text-info"
                  >
                    <option :value="false">{{$t('matchTx.asc')}}</option>
                    <option :value="true">{{$t('matchTx.desc')}}</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col lg="5" class="my-1">
              <b-form-group
                :label="$t('matchTx.initSort')"
                label-for="initial-sort-select-shipShoreConsd"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="lg"
                class="mb-0"
              >
                <b-form-select
                  id="initial-sort-select-shipShoreConsd"
                  v-model="sortDirectionConsd"
                  :options="['asc', 'desc', 'last']"
                  size="lg"
                  class="text-info"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="5" class="my-1">
              <b-form-group
                :label="$t('matchTx.filter')"
                label-for="filter-input-shipShoreConsd"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="lg"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input-shipShoreConsd"
                    v-model="filterConsd"
                    type="search"
                    :placeholder="$t('matchTx.typeToSearch')"
                    class="text-info"
                    style="font-size: 18px;"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button size="md" variant="primary" :disabled="!filterConsd" @click="filterConsd = ''">
                      {{ $t('matchTx.clear') }}
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col lg="5" class="my-1">
              <b-form-group
                v-model="sortDirectionConsd"
                :label="$t('matchTx.filterOn')"
                :description= "$t('matchTx.uncheck')"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="lg"
                class="mb-0"
                v-slot="{ ariaDescribedbyConsd }"
              >
                <b-form-checkbox-group
                  v-model="filterOnConsd"
                  :aria-describedby="ariaDescribedbyConsd"
                  class="mt-1 text-info"
                  plain
                >
                  <b-form-checkbox value="bkgId">{{ $t('matchTx.bkgId') }}</b-form-checkbox>
                  <b-form-checkbox value="contNo">{{ $t('matchTx.contNo') }}</b-form-checkbox>     
                  <b-form-checkbox value="contSize">{{ $t('matchTx.contSize') }}</b-form-checkbox>   
                  <b-form-checkbox value="contType">{{ $t('matchTx.contType') }}</b-form-checkbox>   
                  <b-form-checkbox value="contGrade">{{ $t('matchTx.contGrade') }}</b-form-checkbox>
                  <b-form-checkbox value="sealNo">{{ $t('matchTx.sealNo') }}</b-form-checkbox>  
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="row justify-content-start ml-2">
            <feather 
                @click="refresh" 
                class="text-primary" 
                type="refresh-cw"  
                size="25" 
                v-b-popover.hover.top="$t('approvedTrans.refreshTaskListMsg')">
            </feather>  
              <span class="texrt-dark mx-2"> {{ $t('approvedTrans.asOf') }}</span>
              <span class="text-primary"> {{ asOf }} </span>   
          </div>
          <b-table
            sticky-header
            head-variant="light"
            table-variant="info"
            show-empty
            sort-icon-left
            stacked="md"
            :busy="isBusy"
            :sort-by.sync="sortByConsd"
            :sort-desc.sync="sortDescConsd"
            :sort-direction="sortDirectionConsd"
            :filter="filterConsd"
            :filter-included-fields="filterOnConsd"
            :items="itemsConsd"
            :fields="fieldsConsd"
            :current-page="currentPageConsd"
            :per-page="perPageConsd"
            @filtered="onFilteredConsd"
          >
            <template #cell(contImageConsd)="row" >
              <b-button  size="md" @click="openModalImageConsd(row.item, $event.target )" class="m-1">
                {{ row.item.contNo }}
              </b-button>
            </template>
            <template #cell(actShoreConsd)="row" >
              <b-button v-show="row.item.status != 'cancel'"  size="sm" variant="warning" @click="actShoreEditConsd(row.item)" class="m-1">
                {{ $t('approvedTrans.edit') }}
              </b-button>
              <b-button v-show="row.item.status == 'accept'"  size="sm" variant="danger" @click="actRejectConsd(row.item)" class="m-1">
                {{ $t('matchTx.reject') }}
              </b-button>
              <b-button v-show="row.item.status == 'reject' || row.item.status == 'cancel' "  size="sm" variant="success" @click="actAcceptConsd(row.item)" class="m-1" v-b-popover.hover.top="$t('shipShore.actShipShoreAcceptMsg')">
                {{ $t('matchTx.accept') }}
              </b-button>
              <b-button  v-show="row.item.status == 'accept'" size="sm" variant="danger" @click="actCancelConsd(row.item)" class="m-1 ">
              {{ $t('matchTx.cancel') }}
            </b-button>
            </template>
            <template #cell(actInfoConsd)="row" >
              <b-button size="sm" variant="info" @click="actEirRels(row.item)" class="m-1" v-b-popover.hover.top="$t('matchTx.eirRelsMsg')" >
                {{ $t('matchTx.eirRels') }}
              </b-button>
              <b-button size="sm" variant="info" @click="actEirRecv(row.item)" class="m-1" v-b-popover.hover.top="$t('matchTx.eirRecvMsg')">
                {{ $t('matchTx.eirRecv') }}
              </b-button>
            </template>
            <template #empty>
                <h5>{{ $t('reuse.noRecord') }}</h5>
            </template>
          </b-table>
          <b-row>
            <div class="row col-sm-4 ">
              <b-col class="my-1 ml-3">
                <b-pagination
                  v-model="currentPageConsd"
                  :total-rows="totalRowsConsd"
                  :per-page="perPageConsd"
                  align="fill"
                  class="my-0"
                ></b-pagination>
              </b-col>   
              <b-col sm="3" md="6" class="my-1">
                <b-form-group
                  :label= "$t('require.perPage')"
                  label-for="per-page-selectConsd"
                  label-cols-sm="6"
                  label-cols-md="4"
                  label-cols-lg="3"
                  label-align-sm="right"
                  label-size="sm"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-selectConsd"
                    v-model="perPageConsd"
                    :options="pageOptionsConsd"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </div>
          </b-row>
          <b-modal id="contModalConsd" :title="modalTitle" ok-only @hide="resetInfoModal">
            <div class="row my-2">
              <h5 class="text-primary ml-2"> {{ $t('container.contNo') }}</h5>               
              <span class="text-info ml-2">{{ modalContNo }}</span>                  
            </div>
            <div class="gradient-yg p-1" >
                <div class="dashboard">
                    <div class="image-scroll-container">
                        <div class="image-scroll" ref="scrollContainer">
                            <div
                            class="image-item"
                            v-for="(image, index) in imageUriModal"
                            :key="image.id"
                            >
                            <img :src="image.url" :alt="'Image ' + (index + 1)" class="display-image">
                            <span class="image-counter">{{ index + 1 }} of {{ imageUriModal.length }}</span>
                            </div>
                            <div v-if="imageUriModal.length === 0" class="no-images">
                            {{$t('approvedTrans.noImageYet') }}
                            </div>
                        </div>
                        <div class="scroll-controls" v-if="imageUriModal.length > 1">
                            <button @click="scrollLeft" class="scroll-btn">&lt;&lt;</button>
                            <button @click="scrollLeftS1" class="scroll-btn mx-2">&lt;</button>
                            <button @click="scrollRightS1" class="scroll-btn mx-2">&gt;</button>
                            <button @click="scrollRight" class="scroll-btn">&gt;&gt;</button>
                        </div>
                    </div>                        
                </div>
            </div>
          </b-modal>  
          <b-modal
            id="shoreEditConsd-modal" 
            :title="$t('shipShore.shoreEditConsdModalTitle')"
            v-model="showShoreEditConsdModal"
            header-bg-variant="info"
            header-text-variant="dark"
            body-bg-variant="light"
            body-text-variant="dark"
            hide-footer
          >
            <div class="form-row">
                <h3 class="text-primary">{{ $t('shipShore.shoreEditData') }}</h3>              
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="vessel" class="col-form-label text-primary f-w-600">{{ $t('shipShore.vessel') }}</label>
                        <input class="form-control" id="vessel" v-model="vessel" type="text" :placeholder="$t('shipShore.vesselPh') ">
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="voyageNo" class="col-form-label text-primary f-w-600">{{ $t('shipShore.voyageNo') }}</label>
                        <input class="form-control" id="voyageNo" v-model="voyageNo" type="text" :placeholder="$t('shipShore.voyageNoPh') ">
                    </div>
                </div>                
                <div class="col-md-6">
                  <div class="form-group">
                      <label for="destPort" class="col-form-label text-primary f-w-600">{{ $t('matchTx.destPort') }}</label>
                      <input class="form-control" id="destPort" v-model="destPort" type="text">
                  </div>
                </div>  
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="remark" class="col-form-label text-primary f-w-600">{{ $t('shipApproval.rejectRemark') }}</label>
                    <input
                      class="form-control"
                      id="remark-input"
                      v-model="remark"
                      type="text"
                      :placeholder="$t('shipApproval.rejectRemarkPh')"
                      style="font-size: 16px;"
                    >                  
                  </div>
              </div>
            </div>
            <div class="w-100">
              <b-button
                variant="primary"
                size="md"
                class="float-right"
                @click="clickShoreEditConsd_OK"
              >
              {{ $t('truck.ok') }}
              </b-button>              
              <b-button
                variant="warning"
                size="md"
                class="float-right"
                @click="clickShoreEditConsd_NO"
              >
                {{ $t('matchTx.no') }}
              </b-button>
            </div>
          </b-modal>                       
          <b-modal
          id="exportXls-modal" 
          :title="$t('shipShore.exportXlsModalTitle')"
          v-model="showExportXlsModal"
          header-bg-variant="primary"
          header-text-variant="white"
          body-bg-variant="light"
          body-text-variant="dark"
          hide-footer
          >
          <div class="row mx-3 my-2">
            <label class="f-w-600 mx-2 mt-2" style="font-size:16px;">{{ $t("bill.startDate") }} :</label>
              <datepicker 
                v-model="startDate"
                input-class="datepicker-here form-control digits" 
                :disabled-dates="disabledDates"
                :placeholder="$t('shipShore.startDatePh')"
                :format="format"  >
              </datepicker>
          </div> 
          <div class="w-100">
            <b-button
              variant="primary"
              size="md"
              class="float-right mt-2"
              @click="clickAllStatus_Export"
            >
            {{ $t('shipShore.allStatusExport') }}
            </b-button>   
            <b-button
              variant="primary"
              size="md"
              class="float-right mx-3 mt-2 "
              @click="clickAcceptStatus_Export"
            >
            {{ $t('shipShore.acceptStatusExport') }}
            </b-button>      
            <b-button
              variant="warning"
              size="md"
              class="float-right mt-2"
              @click="clickExport_NO"
            >
              {{ $t('matchTx.no') }}
            </b-button>
          </div>
          </b-modal>  
        </div>
        <ReportEIR
          ref="pdfComponent"
          :actEirAtLoc="actEirAtLoc"
          :inspData = "inspData"
          :refNo = "selectedMatchTx.mTxId"
          :selectedItemInfo = "selectedMatchTx"
          :transCompInfo = "transCompInspEIR"
          :contUrl = "urlx"
          @progress="handleProgress"
        >
        </ReportEIR>
      </div>
    </b-container>
  </div>
</template>
<script>

import { compNameEngByCompId, shoreAgentStartDate ,getData, mergeObj, updateStatus } from "../../firebase"
import {exportXlsx } from "../../utilities/util" 
import ReportEIR from "../../components/ReportEIR.vue"
  export default {
    name: 'shipShore',
    components : { ReportEIR},
    data() {
      return {
        urlx : [],
        progressValue : 0,
        isGenerating : false,
        asOf : this.$moment().format( "HH:mm,  DD-MM-YYYY"),
        compId : '',
        compNameEng : '',
        shipShoreStartDateTS : 0,
        items: [],
        fields: [
          { key: 'shoreId', label: this.$t('shipShore.shoreId'), sortable: true, },  
          { key: 'bkgId', label: this.$t('require.bkgId'), sortable: true, },     
          { key: 'contImage', label: this.$t('matchTx.contNo'), sortable: true, variant: 'info'},       
          { key: 'contType', label: this.$t('matchTx.contType'), sortable: true, },
          { key: 'contSize', label: this.$t('matchTx.contSize'), sortable: true, },
          { key: 'contGrade', label: this.$t('matchTx.contGrade'), sortable: true, },
          { key: 'tare', label: this.$t('container.tare'), sortable: true, },
          { key: 'sealNo', label: this.$t('matchTx.sealNo'), sortable: true, },
          { key: 'agent', label: this.$t('matchTx.agent'), sortable: true, },                
          { key: 'destPort', label: this.$t('matchTx.destPort'), sortable: true, },
          { key: 'cargoDesc', label: this.$t('matchTx.cargoDesc'), sortable: true, },
          { key: 'cargoWeight', label: this.$t('matchTx.cargoWeight'), sortable: true, },
          { key: 'cargoOwner', label: this.$t('matchTx.cargoOwner'), sortable: true, },   
          { key: 'compNameLocalReqr', label: this.$t('shipShore.compNameLocalReqr'), sortable: true, variant: 'primary'},                
          { key: 'actInfo', label: this.$t('shipShore.actInfo'), sortable: true, variant: 'primary'}, 
          { key: 'status', label: this.$t('approvedTrans.transStatus'), sortable: true,variant: 'warning',
            formatter: value => {
              return this.$t(`matchTx.${value}`)
          } },
          { key: 'actShore', label: this.$t('shipShore.actShore'), sortable: true, variant: 'primary'},  
          { key: 'timestamp', label: this.$t('shipApproval.date'), sortable: true, variant: 'secondary',
            formatter: value => {
              return this.$moment(value).format("DD-MM-YY @ HH:mm")
          }}, 
          { key: 'remark', label: this.$t('approvedTrans.remark'), sortable: true, },                
        ],
        isBusy: false,   
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
        sortBy: 'timestamp',
        sortDesc: true,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        itemsConsd: [],
        fieldsConsd: [
          { key: 'shoreId', label: this.$t('shipShore.shoreId'), sortable: true, },
          { key: 'vessel', label: this.$t('shipShore.vessel'), sortable: true, variant: 'warning'},
          { key: 'voyageNo', label: this.$t('shipShore.voyageNo'), sortable: true,variant: 'warning' },
          { key: 'destPort', label: this.$t('matchTx.destPort'), sortable: true, },        
          { key: 'agent', label: this.$t('matchTx.agent'), sortable: true, },                    
          { key: 'bkgId', label: this.$t('require.bkgId'), sortable: true, },     
          { key: 'contImageConsd', label: this.$t('matchTx.contNo'), sortable: true, variant: 'info'},       
          { key: 'contType', label: this.$t('matchTx.contType'), sortable: true, },
          { key: 'contSize', label: this.$t('matchTx.contSize'), sortable: true, },
          { key: 'contGrade', label: this.$t('matchTx.contGrade'), sortable: true, },
          { key: 'tare', label: this.$t('container.tare'), sortable: true, },
          { key: 'sealNo', label: this.$t('matchTx.sealNo'), sortable: true, },
          { key: 'cargoDesc', label: this.$t('matchTx.cargoDesc'), sortable: true, },
          { key: 'cargoWeight', label: this.$t('matchTx.cargoWeight'), sortable: true, },
          { key: 'cargoOwner', label: this.$t('matchTx.cargoOwner'), sortable: true, },   
          { key: 'compNameLocalReqr', label: this.$t('shipShore.compNameLocalReqr'), sortable: true, variant: 'primary'},                
          { key: 'actInfoConsd', label: this.$t('shipShore.actInfo'), sortable: true, variant: 'primary'}, 
          { key: 'status', label: this.$t('approvedTrans.transStatus'), sortable: true,variant: 'warning',
            formatter: value => {
              return this.$t(`matchTx.${value}`)
          } },
          { key: 'actShoreConsd', label: this.$t('shipShore.actShore'), sortable: true, variant: 'primary'},  
          { key: 'timestamp', label: this.$t('shipApproval.date'), sortable: true, variant: 'secondary',
            formatter: value => {
              return this.$moment(value).format("DD-MM-YY @ HH:mm")
          }}, 
          { key: 'remark', label: this.$t('approvedTrans.remark'), sortable: true, },          
        ],
        totalRowsConsd: 1,
        currentPageConsd: 1,
        perPageConsd: 10,
        pageOptionsConsd: [5, 10, 15, { value: 100, text: "Show a lot" }],
        sortByConsd: 'timestamp',
        sortDescConsd: true,
        sortDirectionConsd: 'asc',
        filterConsd: null,
        filterOnConsd: [],
        showEirModal: false,
        imageUriModal: [],
        modalTitle : '',
        modalContNo: '',
        inspData : '',
        transCompInspEIR : '',
        actEirAtLoc : '',
        selectedMatchTx: '',
        selectedItem: '',
        showShipShoreRejectModal : false,        
        showShipShoreAcceptModal : false,
        shoreId : '',
        vessel: '',
        voyageNo: '',
        destPort: '',
        remark : '',
        showShoreEditConsdModal : false,
        showExportXlsModal : false,
        format: "yyyy MM dd",
        startDate : '',
        disabledDates: {
          to : new Date(Date.parse(new Date())-2678400000),
          from: new Date(Date.parse(new Date())),
        },
      }
    },
    computed: {
      htmlToPdfOptions(){
        return {
          margin: 0,
          filename: `EIR${this.selectedMatchTx.mTxId}`,
          image: {
            type: 'jpg', 
            quality: 0.98
          },
          enableLinks: false,
          html2canvas: {
            scale: 1,
            useCORS: true
          },
        }
      },
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      },
      sortOptionsConsd() {
        // Create an options list from our fields
        return this.fieldsConsd
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      },
    },
    
    mounted() {
      this.compId= localStorage.getItem("compId")
      this.shipShoreStartDateTS = Date.parse(new Date()) - 7905600000 // 3 months back
      compNameEngByCompId(this.compId , async(nameEng)=>{
         // = agent (controlled menu by compId under (userCat = agent) when login/register)
        this.compNameEng = nameEng
        await shoreAgentStartDate(nameEng,  [ "waitAccept" ], this.shipShoreStartDateTS, (res)=>{
          this.items = res
          this.totalRows = res.length
        })
        await shoreAgentStartDate(nameEng,  [ "accept" , "reject" , "cancel" ,'sentPort' ], this.shipShoreStartDateTS, (res)=>{
          this.itemsConsd = res
          this.totalRowsConsd = res.length
        })
      }) 
    },
    methods: {
      shipApproval(){
        this.$router.push('/dashboard/shipApproval')
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      onFilteredConsd(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRowsConsd = filteredItems.length
        this.currentPageConsdr = 1
      },
      async refresh() {
        this.isBusy = true
        await shoreAgentStartDate(this.compNameEng, ["waitAccept"],  this.shipShoreStartDateTS,(res)=>{
          this.items = res
          this.totalRows = res.length
          this.isBusy = false
        })
        await shoreAgentStartDate(this.compNameEng, [ "accept" , "reject" , "cancel", 'sentPort' ], this.shipShoreStartDateTS, (res)=>{
          this.itemsConsd = res
          this.totalRowsConsd = res.length
          this.isBusy = false
        })
        this.asOf = this.$moment().format( "HH:mm,  DD-MM-YYYY")
      },
      actShipShoreReject(item) {
        this.selectedItem = item
        this.showShipShoreRejectModal=true
      }, 
      async clickShipShoreReject_NO(){
        this.selectedItem = ''
        this.showShipShoreRejectModal=false
      },
      async clickShipShoreReject_OK(){
        if (this.remark == '' ) {
          this.$toasted.show( this.$t('shipApproval.addRejectRemark'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});  
        } else {
          let obj = {
              remark : this.remark,       
              status : 'reject',
              timestamp: Date.parse(new Date()),
          }
          await mergeObj('Shore', this.selectedItem.shoreId, obj).then(()=>{
            this.refreshShoreData()
            this.showShipShoreRejectModal = false            
            this.$toasted.show(this.$t('shipShore.successRejectShore'), {theme: 'bubble', type: 'warning' , position: 'bottom-center', duration: 8000});  
          })  
          await mergeObj('MatchTx', this.selectedItem.shoreId ,{
              shoreStatus : 'reject'
            })
        }
      },
      async actShipShoreAccept(item) {
        this.selectedItem = item
        this.destPort = item.destPort
        this.showShipShoreAcceptModal = true
      },
      clickShipShoreAccept_NO(){
        this.selectedItem = ''
        this.destPort = ''
        this.showShipShoreAcceptModal = false
      },
      async clickShipShoreAccept_OK(){
        let msg = 'completed'
        if (this.vessel ===''){
            msg = 'shipShore.addVessel'
        } else if (this.voyageNo ===''){
            msg = 'shipShore.addVoyageNo'                        
          } else if (this.destPort ==='') {
            msg = 'matchTx.addDestPort'
        }  
        if (msg === 'completed'){
          let payload = {
              vessel : this.vessel,
              voyageNo : this.voyageNo,
              destPort : this.destPort,        
              status : 'accept',
              timestamp: Date.parse(new Date()),
          }
          console.log(`shoreId,acceptOK => ${this.selectedItem.shoreId}`)
          await mergeObj('Shore', this.selectedItem.shoreId, payload).then(async()=>{
            this.refreshShoreData()
            await this.refresh()
            this.showShipShoreAcceptModal = false            
            this.$toasted.show(this.$t('shipShore.successAcceptShore'), {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 8000});  
          })  
          await mergeObj('MatchTx', this.selectedItem.shoreId ,{
              shoreStatus : 'accept',
              timestamp: Date.parse(new Date())
            })        
        }else{
            this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
        }  
      },
      async actAcceptConsd(item) {
        this.selectedItem = item
        this.vessel = item.vessel
        this.voyageNo = item.voyageNo
        this.destPort = item.destPort
        this.remark = item.remark
        this.showShipShoreAcceptModal = true
      },
      async actShoreEditConsd(item) {
        this.selectedItem = item
        this.vessel = item.vessel
        this.voyageNo = item.voyageNo
        this.destPort = item.destPort
        this.remark = item.remark
        this.showShoreEditConsdModal = true
      },
      clickShoreEditConsd_NO(){
        this.vessel = ''
        this.voyageNo = ''
        this.destPort = ''
        this.remark = ''
        this.showShoreEditConsdModal = false
      },
      async clickShoreEditConsd_OK(){
        let msg = 'completed'
        if (this.vessel ===''){
            msg = 'shipShore.addVessel'
        } else if (this.voyageNo ===''){
            msg = 'shipShore.addVoyageNo'                        
          } else if (this.destPort ==='') {
            msg = 'matchTx.addDestPort'
        }  
        if (msg === 'completed'){
          let payload = {
              vessel : this.vessel,   // mTxId
              voyageNo : this.voyageNo,
              destPort : this.destPort,
              remark : this.remark,
              status : 'accept',
              timestamp: Date.parse(new Date()),
          }
          await mergeObj('Shore', this.selectedItem.shoreId, payload).then(()=>{
            this.refreshShoreData()
            this.refresh()
            this.showShoreEditConsdModal = false            
            this.$toasted.show(this.$t('shipShore.successEditShore'), {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 8000});  
          })  
          await mergeObj('MatchTx', this.selectedItem.shoreId ,{
            shoreStatus : 'accept',
            timestamp: Date.parse(new Date())
          })  
        }else{
            this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
        }  
      },
      refreshShoreData(){
        this.selectedItem = ''
        this.destPort = ''
        this.vessel = ''
        this.voyageNo = ''
        this.remark = ''
      },

      actRejectConsd(item) {
        this.$bvModal.msgBoxConfirm(this.$t('shipShore.confirmRejectMsg'), {
          title: this.$t('matchTx.plsConfirm'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'warning',
          okTitle: this.$t('matchTx.yes'),
          cancelTitle: this.$t('matchTx.no'),
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(async(value) => {
            if (value) {
              await updateStatus( 'Shore' , item.shoreId , 'reject')
              await mergeObj('MatchTx', item.shoreId ,{
                shoreStatus : 'reject',
                timestamp: Date.parse(new Date())
              })  
              await this.refresh()
            } else {
              return
            }
          })
          .catch(error => {
            this.$toasted.show( `Action-Reject-Considered Shore : ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});  
          })
      },   
      actCancelConsd(item) {
        this.$bvModal.msgBoxConfirm(this.$t('shipShore.confirmCancelMsg'), {
          title: this.$t('matchTx.plsConfirm'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'warning',
          okTitle: this.$t('matchTx.yes'),
          cancelTitle: this.$t('matchTx.no'),
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(async(value) => {
            if (value) {
              await updateStatus( 'Shore' , item.shoreId , 'cancel')
              await mergeObj('MatchTx', item.shoreId ,{
                shoreStatus : 'cancel',
                timestamp: Date.parse(new Date())
              })  
              await this.refresh()
            } else {
              return
            }
          })
          .catch(error => {
            this.$toasted.show( `Action-Cancel-Considered Shore : ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});  
          })
      },   

      async exportAccept2Port_excel(){
        this.showExportXlsModal = true
      },
      clickExport_NO(){
        this.showExportXlsModal = false
      },
      async clickAcceptStatus_Export(){
        if (this.startDate == '') {
          this.$toasted.show(this.$t('shipShore.addStartDate'), {theme: 'bubble', type: 'warning' , position: 'bottom-center', duration: 6000});  
        } else {
          await shoreAgentStartDate(this.compNameEng, ["accept"], Date.parse(this.startDate), (res)=>{
            console.log(`res,clickAcceptStatus_Export=> ${JSON.stringify(res, null , 2)}`)
            if (res.length == 0) {
              this.$toasted.show(this.$t('shipShore.noShoreRequestAccept'), {theme: 'bubble', type: 'warning' , position: 'bottom-center', duration: 6000});  
            } else {
              exportXlsx(res , `SHORE-${this.$moment().format("YYYY-MM-DD-HH-mm")}`)
              this.showExportXlsModal = false
            }
          })          
        }
      },
      async clickAllStatus_Export(){
        if (this.startDate == '') {
          this.$toasted.show(this.$t('shipShore.addStartDate'), {theme: 'bubble', type: 'warning' , position: 'bottom-center', duration: 6000});  
        } else {
          await shoreAgentStartDate(this.compNameEng, ["accept" , "reject" , "cancel" ],  Date.parse(this.startDate), (res)=>{
            console.log(`res,clickAllStatus_Export=> ${JSON.stringify(res, null , 2)}`)
            if (res.length == 0) {
            this.$toasted.show(this.$t('shipShore.noShoreRequestAll'), {theme: 'bubble', type: 'warning' , position: 'bottom-center', duration: 6000});  
            } else {
              exportXlsx(res , `SHORE-${this.$moment().format("YYYY-MM-DD-HH-mm")}`)
              this.showExportXlsModal = false
            }              
          })
        }
      },
      startDownload() {
        this.isGenerating = true
        this.progressValue = 0
        // สั่งให้ Sub-component เริ่มทำงาน
        this.$refs.pdfComponent.generate()
      },
      handleProgress(val) {
        this.progressValue = val
        // เมื่อครบ 100% ให้รีเซ็ตสถานะ
        if (val === 100) {
          setTimeout(() => {
            this.isGenerating = false
          }, 1000)
        }
      },
      async actEirRels(item){
        await this.actEir(item, 'EIR', 'Cont6Images')
        this.actEirAtLoc = 'rels'
      },
      async actEirRecv(item){
        await this.actEir(item, 'EirRecv', 'Cont6ImagesRecv')
        this.actEirAtLoc = 'recv'
      },
      async actEir(item ,  eirColl , imgColl) {
        await getData('MatchTx', 'mTxId' , item.shoreId, (mTx)=>{
          this.selectedMatchTx = mTx[0]
        })
        await getData( eirColl , 'contId' , item.contId, async(res)=>{
          if (res.length != 0 && res[0].sumResult != '') {
            this.inspData = res[0]
            await getData(imgColl , 'contId', item.contId , (contImg)=>{
              if (contImg.length != 0) {
                this.urlx = contImg[0].url6   // for Components : ReportEIR
               // console.log(`[this.urlx] =>  ${JSON.stringify(this.urlx, null, 2)}`)
              }
            })            
            await getData('Company', 'compId', res[0].compId , (comp)=>{
              if (comp.length != 0) {
                this.transCompInspEIR = comp[0]
                this.startDownload()
              }
            })            

          } else {
            this.$toasted.show(this.$t('shipShore.noInspdEir'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
          }
        })
      },

      async openModalImage(item, button) {
        await getData( 'Container' , 'contId' , item.contId , (res)=>{
          this.imageUriModal = res[0].url6
          this.modalTitle = `${this.$t('matchTx.condId')} : ${res[0].contId}`
          this.modalContNo = res[0].contNo
          this.$root.$emit('bv::show::modal', "contModal" , button)        
        })

      },
        async openModalImageConsd(item, button) {
          await getData( 'Container' , 'contId' , item.contId , (res)=>{
          this.imageUriModal = res[0].url6
          this.modalTitle = `${this.$t('matchTx.condId')} : ${res[0].contId}`
          this.modalContNo = res[0].contNo
          this.$root.$emit('bv::show::modal', "contModalConsd" , button)               
        })
      },
      resetInfoModal() {
        this.modalTitle = ''
        this.modalContNo = ''
        this.imageUriModal = []
      },
      scrollLeft() {
        this.$refs.scrollContainer.scrollBy({
            left: -window.innerWidth * 1.0,
            behavior: 'smooth'
        });
        },  
        scrollLeftS1() {
        this.$refs.scrollContainer.scrollBy({
            left: -window.innerWidth * 0.2,
            behavior: 'smooth'
        });
        }, 
        scrollRight() {
        this.$refs.scrollContainer.scrollBy({
            left: window.innerWidth * 1.0,
            behavior: 'smooth'
        });
        },
        scrollRightS1() {
        this.$refs.scrollContainer.scrollBy({
            left: window.innerWidth * 0.2,
            behavior: 'smooth'
        });
        },
    }
  }
</script>
<style scoped>
.divider {
    height: 1px;
    background-color: #0f0f0f;
    margin:5px
}
.display-image {
  width: 100%;
  height: 450px;
  object-fit: scale-down;
  border-radius: 8px;
  background-color: #f5f5f5;
}

 .gradient-gy {
   background: linear-gradient(135deg, green, yellow);
 }
 .gradient-yg {
   background: linear-gradient(135deg, yellow, green);
 }
 .gradient-wy {
   background: linear-gradient(135deg, white, yellow);
 }

 /* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 17px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* THIS IS WHERE YOU SET THE BACKGROUND COLOR WHEN OFF */
  background-color: #ccc; /* Example: Gray when off */
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

/* Change background color of the slider when checked (ON state) */
input:checked + .slider {
  /* THIS IS WHERE YOU SET THE BACKGROUND COLOR WHEN ON */
  background-color: #2196F3; /* Example: Blue when on */
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(13px);
  -ms-transform: translateX(13px);
  transform: translateX(13px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 17px;
}

.slider.round:before {
  border-radius: 50%;
}
.gradient-yg {
   background: linear-gradient(135deg, yellow, green);
 }
 .dashboard {
  padding: 10px;
  max-width: 100%;
  overflow-x: hidden;
}
.image-scroll-container {
  position: relative;
  margin: 20px 0;
}

.image-scroll {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch; /* For smooth scrolling on iOS */
  scrollbar-width: none; /* Hide scrollbar for Firefox */
  width: 100%;
}

.image-scroll::-webkit-scrollbar {
  display: none; /* Hide scrollbar for Chrome/Safari */
}

.image-item {
  flex: 0 0 100%;
  scroll-snap-align: start;
  position: relative;
  padding: 0 5px;
  box-sizing: border-box;
}
.display-image {
  width: 100%;
  height: 450px;
  object-fit: contain;
  border-radius: 8px;
  background-color: #f5f5f5;
}
.image-counter {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 14px;
}

.no-images {
  text-align: center;
  width: 100%;
  padding: 50px 0;
  color: #666;
  font-style: italic;
  font-size: 16px;
}

.scroll-controls {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.scroll-btn {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 8px 15px;
  margin: 0 5px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}
</style>